import WMSLayer from '@arcgis/core/layers/WMSLayer';
import PropTypes from 'prop-types';

/**
 * Create a WMS (Web Map Services) layer instance from a service url and layer names.
 * https://developers.arcgis.com/javascript/latest/api-reference/esri-layers-WMSLayer.html
 * @param {String} url - GIS WMS service url
 * @param {Array} layerNames - Collection of WMS service sublayer names to be displayed on the map
 * @param {Object} wmsLayerProps - Additional WMS layer properties that can be passed, check the
 * documentation for a list of all the properties that may be passed into the constructor
 */
export const createWMSLayer = async ({ url, layerNames, ...wmsLayerProps }) =>
  await handleWMSLayer({ url, layerNames, ...wmsLayerProps });

async function handleWMSLayer({ url, layerNames, ...wmsLayerProps }) {
  const sublayers = layerNames?.length
    ? layerNames.map(name => ({ name }))
    : null;

  const wmsLayer = new WMSLayer({
    url,
    sublayers,
    ...wmsLayerProps,
  });

  // Layer must be loaded so that layer properties can be queried.
  // https://developers.arcgis.com/javascript/latest/api-reference/esri-layers-WMSLayer.html#load
  await wmsLayer.load();

  // TODO: Wait for feedback from the product team on WMS layer error handling.
  // Intercepts the WMS API requests and check for errors. This can occur when the user is viewing
  // an area on the map where the web map images are unavailable.
  // https://developers.arcgis.com/javascript/latest/api-reference/esri-config.html#RequestInterceptor
  // esriConfig.request.interceptors.push({
  //   urls: url,
  //   error: error => {
  //     console.log('WMS API request error', error);
  //   },
  // });

  return wmsLayer;
}

createWMSLayer.PropType = {
  url: PropTypes.string.isRequired,
  layerNames: PropTypes.arrayOf(PropTypes.string).isRequired,
};
